import { css, styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const { carbon, midnight } = colorsPalettes;

export const StyledTrafficShareWrapper = styled(Flex)<{ isPrimary: boolean; align?: "left" | "right" }>`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: ${({ align }) => (align === "left" ? "flex-start" : "flex-end")};

    .sw-progress-bar {
        height: 31px;
        background: ${carbon[25]} !important;
    }

    ${({ isPrimary }) =>
        isPrimary &&
        css`
            {
                font-weight: 700;
            }
        `}
    ${({ isPrimary }) =>
        !isPrimary &&
        css`
            .sw-progress-bar-inner {
                background: ${midnight[50]};
            }
        `}
`;

export const StyledCellContainer = styled(Flex)`
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const StyledTableContainer = styled.div`
    width: 100%;
    height: 100%;

    & .ant-table-row-hover {
        background: ${carbon[25]};
    }
`;

export const TrendContainer = styled.div`
    top: 0;
    position: relative;
    pointer-events: none;
`;
